import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCallinScript extends Layout {
    labelTitle: Label;
    panelCallinScriptJumpTo: Panel;
    panelCallinScripts: Panel;
    panelHeaderScripts: Panel;
    sourceCallin: DataSource;
    sourceCallinStop: DataSource;
    sourceDispatch: DataSource;
    textboxCallinScriptPreview: Textbox;
    textboxCallinScriptTemplate: Textbox;
}
